<template>
    <div class="notice">
        <div>
            <h4 :id="notice.id" class="notice-title">{{ notice.title }}</h4>
            <p v-if="notice.subtitle" class="notice-subtitle">{{ notice.subtitle }}</p>
        </div>
        <a
            v-if="notice.path && notice.path.alias"
            class="button notice-link"
            :href="notice.path.alias"
            :aria-labelledby="notice.id"
        >
            {{ t('details') }}
        </a>
    </div>
</template>
<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
    notice: {
        type: Object,
        default: () => ({}),
    },
    noRoute: {
        type: String,
        required: true,
    },
});

const { t } = useI18n({
    messages: {
        fr: {
            details: 'Détails',
        },
        en: {
            details: 'Details',
        },
    },
});
</script>

<style lang="scss" scoped>
.notice {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    @include breakpoint(medium) {
        flex-direction: row;
        align-items: center;
    }
}
.notice-title {
    @include rem-typo(18px);
    margin: 4px 0 8px;
    font-weight: 700;
    @include breakpoint(medium) {
        @include rem-typo(18px);
        margin: 0;
    }
}
.notice-subtitle {
    @include rem-typo(16px);
    margin: 0 0 16px;
    color: $color-black-70;
    @include breakpoint(medium) {
        @include rem-typo(18px);
        margin: 0;
    }
}
.notice-link {
    text-decoration: none;
}
</style>
